import { h, Component } from 'preact';
import style from './style'
import {FAPaw, FAUser} from 'components/elements/FontAwesome'


export default (props)=>{
	const hw = props.horizontalWide ? style.horizontalWide : ''
	return (
		<div onClick={props.onSelect} class={[style.select, hw].join(' ')}>
			<div selected={props.selected}>
				<div class={style.icon}>
                    {props.genericPatients ?
                        <FAUser class={style.selectIcon} />
                    :
                        <FAPaw class={style.selectIcon} />
                    }
				</div>
				<div class={style.name}>
					{props.firstName ? props.firstName : 'none'}
					&nbsp;{props.lastName}
				</div>
			</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./components/groups/PatientSelectCard/index.js